import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Form, Table, Loader, Label} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {getUrl} from '../../constants';
import SearchFormMany from './SearchFormMany';
import HeaderActions from './HeaderActions';
import QueryTable from './QueryTable';
import './styles.scss';

class ProcessedWarranty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'account': null,
      'initDate': null,
      'endDate': null,
      'typeTwc': 'TODOS',
      'status': 'TODOS',
      'invoice': '',
      'selectedStatus': 'TODOS',
      'twcNum': null,
      'generatedFile': false,
      'filteredRows': [],
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ProcessedWarranty, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchWarrantySequences();
    this.props.fetchWarrantyStatus();
  }

  componentDidUpdate() {
    const {loading} = this.props;

    if (this.state.generatedFile && !loading) {
      this.handleSearch();
      this.setState({'generatedFile': false});
    }
  }

  componentWillUnmount() {
    this.props.clearTwcList();
  }

  handleSearch = () => {
    const {status} = this.state;
    const {dealer} = this.props;
    const url = getUrl(this.state);
    this.props.fetchTwcList(dealer, status, url);
    this.setState({
      'selectedStatus': status,
    });
  }

  handleClear = () => {
    this.setState({
      'initDate': null,
      'endDate': null,
      'typeTwc': 'TODOS',
      'status': 'TODOS',
      'invoice': '',
      'selectedStatus': 'TODOS',
    });
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  handleAccountChange = (event) => {
    const value = event && event.target && event.target.value;
    this.setState({'account': value});
  }

  handleFilterChange = (event) => {
    const value = event && event.target && event.target.value;
    this.setState({'twcNum': value});
  }

  downloadTxtFile = () => {
    const {processedWarrantyList, dealer} = this.props;
    const {twcNum, status, initDate, endDate, typeTwc, account} = this.state;
    const processedList = processedWarrantyList && processedWarrantyList.filter((item) => item.checked === true);
    const params = {
      'account': account,
      'numTwc': twcNum,
      'detail': processedList,
      'dealer': dealer,
      'status': status,
      'initDate': initDate,
      'endDate': endDate,
      'typeTwc': typeTwc,
    };
    this.props.fetchFileData(params);
    this.setState({'generatedFile': true});
  }

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {initDate, endDate, processedStatus, selectedStatus, filteredRows} = this.state;
    const {processedWarrantyList, warrantyStatus, loading, dealer} = this.props;
    const validateManySearch = initDate === null || endDate === null;

    return (
      <div className='warranty-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta de Garantías Procesadas</h2>
              <Label className='warranty-total' color='red'>
                Total garantías
                <Label.Detail>{filteredRows.length}</Label.Detail>
              </Label>
              <HeaderActions
                state={this.state}
                dealer={dealer}
                loading={loading}
                warrantyStatus={warrantyStatus}
                downloadTxtFile={this.downloadTxtFile}
                processedWarrantyList={processedWarrantyList}
                handleAccountChange={this.handleAccountChange}
                handleFilterChange={this.handleFilterChange}
              />
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className='twc-search-container'>
            <Form>
              <label className='invoice-b-10'>Búsqueda de garantías</label>
              <Form.Group widths='equal'>
                <SearchFormMany
                  {...this.state}
                  statusSelect={warrantyStatus}
                  handleChange={this.handleChange}
                />
                <div className='twc-btn-search'>
                  <Button
                    secondary
                    onClick={this.handleClear}
                  >
                    LIMPIAR
                  </Button>
                  <Button
                    disabled={validateManySearch}
                    onClick={this.handleSearch}
                    type='submit'
                    color='green'
                  >
                    BUSCAR
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </div>
        </Card>
        <Card raised fluid className='processed-warranty-table'>
          {loading ? this.renderLoader() :
            <QueryTable
              processedStatus={processedStatus}
              processedWarrantyList={processedWarrantyList}
              removeWarrantyChecked={this.props.removeWarrantyChecked}
              addWarrantyChecked={this.props.addWarrantyChecked}
              handleChange={this.handleChange}
              selectedStatus={selectedStatus}
              filteredRows={filteredRows}
              loading={loading}
            />
          }
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const statusSelect = state.processedWarranty.warrantyStatus.map((item) => ({
    'key': item.status, 'text': item.description.toUpperCase(), 'value': item.status,
  }));
  statusSelect.unshift({'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'});

  return {
    'permissions': state.session.permissions,
    'dealer': state.session.dealerId,
    'processedWarrantyList': state.processedWarranty.processedWarrantyList,
    'warrantySequences': state.processedWarranty.warrantySequences,
    'warrantyStatus': statusSelect,
    'loading': state.processedWarranty.loading,
    'fileData': state.processedWarranty.fileData,
  };
};

const {
  withRouter,
  fetchTwcList,
  clearTwcList,
  fetchFileData,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  navigateTo,
} = Actions;

const mapDispatchToProps = {
  fetchTwcList,
  fetchFileData,
  clearTwcList,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  navigateTo,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProcessedWarranty));

